import React from 'react'
import styled from 'styled-components'

import { linkHovered } from 'styles/colors'

import EditIcon from 'components/icons/Edit'
import ModalButton from 'components/ModalButton'

const Button = styled.button`
  border: none;
  background-color: transparent;
  cursor: pointer;
  outline: none;
`

const Edit = styled(EditIcon)`
  button:focus > &,
  button:hover > & {
    fill: ${linkHovered};
  }
`

const EditModalButton = ({ title, renderForm, className, loading }) => (
  <ModalButton
    title={title}
    loading={loading}
    renderButton={props => (
      <Button {...props} className={className}>
        <Edit />
      </Button>
    )}
    renderModal={renderForm}
  />
)

export default EditModalButton



// WEBPACK FOOTER //
// ./src/components/EditModalButton.js